import { useMemo } from "react";
import { useGetResolvedCatalogQuery } from "@api/mApi";

/**
 * Resolve Oxbo-M catalog codes (entry_key) to their human display_label,
 * shown EXACTLY as stored in the catalog (no casing or punctuation changes).
 * Returns a `(code) => label` function that falls back to the raw code when a
 * label is not found, and to "" for null/undefined. Reuses the same resolved
 * catalog endpoint the NPT activity-code reference already uses, so there is no
 * new network cost beyond one cached catalog fetch per category.
 */
export function useCatalogLabels(categoryKey: string): (code: string | null | undefined) => string {
  const { data } = useGetResolvedCatalogQuery({ categoryKey });
  return useMemo(() => {
    const map = new Map<string, string>();
    for (const e of data?.entries ?? []) map.set(e.entry_key, e.display_label);
    return (code: string | null | undefined) => (code ? (map.get(code) ?? code) : "");
  }, [data]);
}
